<app-follow-cursor class="hidden lg:block"></app-follow-cursor>
<h1 class="sr-only">Zehentmoar</h1>
<img
    src="/images/Logo_Zehentmoar_RGB.svg"
    alt="logo hof zehentmoar"
    class="top-1/2 lg:top-0 left-1/2 z-10 absolute bg-white shadow-md mx-auto -translate-x-1/2 -translate-y-1/2 lg:translate-y-0 ~p-8/12 ~h-32/44 transform"
/>
<div
    class="flex lg:flex-row w-full h-[100dvh] font-futura"
    [ngClass]="
        domhandler.isMobile && isColReverse ? 'flex-col-reverse' : 'flex-col'
    "
>
    <app-section-card
        class="relative flex justify-center items-center w-full lg:w-1/2 h-1/2 lg:h-screen"
        [data]="data().left"
        [isLeft]="true"
        link="apartment/home"
    ></app-section-card>
    <app-section-card
        class="relative flex justify-center items-center w-full lg:w-1/2 h-1/2 lg:h-screen"
        [data]="data().right"
        [isLeft]="false"
        link="hof/home"
    ></app-section-card>
</div>
<div
    class="hidden lg:block bottom-0 left-1/2 z-10 absolute bg-white shadow-md mx-auto p-12 -translate-x-1/2 transform"
>
    <app-language-selection></app-language-selection>
</div>
<div
    class="lg:hidden block top-0 right-0 z-10 absolute bg-white shadow-md mx-auto p-4 rounded-bl-md"
>
    <app-language-selection [isMinimal]="true"></app-language-selection>
</div>
